
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thankyoupage-nueva-valuacion",
      function () {
        return require("private-next-pages/thankyoupage-nueva-valuacion/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/thankyoupage-nueva-valuacion"])
      });
    }
  